import React from "react";
import OurGrowth from "./OurGrowth";

const BlankSpace = () => {
  return (
    <>
      <OurGrowth />
    </>
  );
};

export default BlankSpace;
